/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */

import { useFetchCorporatePlans } from '../../../utils/queries/corporate';
// import AddCorporatePlanModal from '../AddCorporatePlanModal';
import { Table, Tag, Typography } from 'antd';
import { capitalize, find, get, map } from 'lodash-es';
import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { Title } = Typography;

export default function PlansList({ corporateId }) {
  const [isAddCorporatePlanOpen, setAddCorporatePlanOpen] = useState(false);
  const [editCorporatePlanObject, setEditCorporatePlanObject] = useState(null);
  const {
    data: plans,
    isLoading,
    refetch,
  } = useFetchCorporatePlans(corporateId);

  const formatQuotaValue = (freeQuotaType, value) => {
    let formattedValue = '';
    switch (freeQuotaType) {
      case 'KWH':
        formattedValue = `${value} KWH`;
        break;
      case 'DURATION':
        formattedValue = `${value} min`;
        break;
      case 'AMOUNT':
        formattedValue = `₹${value}`;
        break;
      default:
        formattedValue = value;
    }
    return formattedValue;
  };

  const onClickEditIcon = (plan) => {
    setEditCorporatePlanObject(plan);
    setAddCorporatePlanOpen(true);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'NAME',
      render: (name, plan) => <>{plan?.NAME}</>,
      key: 'NAME',
    },
    {
      title: 'Free Quota Type',
      dataIndex: 'FREE_QUOTA_TYPE',
      render: (name, plan) => <>{plan?.FREE_QUOTA_TYPE}</>,
      key: 'FREE_QUOTA_TYPE',
    },
    {
      title: 'Quota Value',
      dataIndex: 'FREE_QUOTA',
      render: (name, plan) => (
        <>
          {plan.FREE_QUOTA_TYPE === 'FREE'
            ? '₹0'
            : formatQuotaValue(plan?.FREE_QUOTA_TYPE, plan?.FREE_QUOTA)}
        </>
      ),
      key: 'FREE_QUOTA',
    },
    {
      title: 'Quota Renew Frequency',
      dataIndex: 'FREE_QUOTA_RENEW_PERIOD',
      render: (name, plan) => (
        <>
          {plan.FREE_QUOTA_TYPE === 'FREE'
            ? 'N/A'
            : capitalize(plan?.FREE_QUOTA_RENEW_PERIOD?.replace(/_/g, ' '))}
        </>
      ),
      key: 'FREE_QUOTA_RENEW_PERIOD',
    },
    {
      title: 'Unit Price',
      dataIndex: 'COST',
      render: (name, plan) => <>₹{plan?.COST}</>,
      key: 'COST',
    },
    {
      title: 'Status',
      dataIndex: 'IS_ACTIVE',
      render: (name, plan) => (
        <Tag color={get(plan, 'IS_ACTIVE') ? 'green' : 'orange'}>
          {get(plan, 'IS_ACTIVE') ? 'Active' : 'Inactive'}
        </Tag>
      ),
      key: 'IS_ACTIVE',
    },
    // {
    //   title: 'Actions',
    //   dataIndex: '',
    //   render: (name, plan) => (
    //     <>
    //       <EditOutlined
    //         onClick={() => {
    //           onClickEditIcon(plan);
    //         }}
    //         style={{ cursor: 'pointer' }}
    //       />
    //     </>
    //   ),
    //   key: '',
    // },
  ];

  const closeAddCorporatePlan = () => {
    setAddCorporatePlanOpen(false);
  };

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Title level={4} style={{ paddingBottom: 2 }}>
        Plans{' '}
        {/* <PlusCircleOutlined
          style={{ color: '#2675b8', cursor: 'pointer' }}
          onClick={() => {
            setAddCorporatePlanOpen(true);
          }}
        /> */}
      </Title>
    </div>
  );

  return (
    <>
      <Table
        style={{ marginTop: 20 }}
        rowKey="key"
        columns={columns}
        dataSource={plans?.data?.length > 0 ? plans?.data : []}
        pagination={false}
        title={() => getTitle()}
      />
      {/* <AddCorporatePlanModal
        corporateId={corporateId}
        editCorporatePlanObject={editCorporatePlanObject}
        isModalVisible={isAddCorporatePlanOpen}
        closeAddCorporatePlan={closeAddCorporatePlan}
        triggerRefreshList={refetch}
      /> */}
    </>
  );
}
